import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { HQBranchDetailsWrapper } from "./styled";
import {
  BackButton,
  Box,
  HeadingStyled,
  SpanStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { Col, Row } from "react-bootstrap";
import { FormDataContainer } from "../settings/styled";
import ViewPage from "../../../components/common/pageView/pageView";
import HQBranchesApi from "../../../services/api/hqBranchesApi";
import TooltipInfo from "../../../components/common/tooltip/InfoTooltip";

const HQBranchDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();

  const [hqBranchDetails, setHqBranchDetails] = useState({});
  const [dataLoading, setDataLoading] = useState(false);

  const getHqBranchDetails = async () => {
    try {
      setDataLoading(true);
      const { data, code } = await HQBranchesApi.getHqBranchDetails(id);
      if (code === 200) {
        setHqBranchDetails(data);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getHqBranchDetails();
  }, [language]);

  return (
    <HQBranchDetailsWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("view_hq_branch")}
            onClick={() => navigate("/org-structure")}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <Box className="content-container">
        {dataLoading ? (
          <ThemeLoader />
        ) : (
          <>
            {hqBranchDetails && (
              <Row className="mt-3">
                <Col md={12} className="mb-4">
                  <FormDataContainer className="dataContainer">
                    <ViewPage
                      label={t("type")}
                      text={
                        parseInt(hqBranchDetails.location_type) === 1
                          ? t("headquarter")
                          : t("branch")
                      }
                    />
                    <ViewPage
                      label={t("name_en")}
                      text={hqBranchDetails.name_en}
                    />
                    <ViewPage
                      label={t("name_ar")}
                      text={hqBranchDetails.name_ar}
                    />
                    <ViewPage
                      label={t("initial_name")}
                      text={hqBranchDetails.initial_name}
                    />
                  </FormDataContainer>
                </Col>
                <Col md={12} className="mb-4">
                  <HeadingStyled
                    size="20px"
                    weight="400"
                    color="var(--text)"
                    className="mb-2"
                  >
                    {t("location")}
                  </HeadingStyled>
                  <FormDataContainer className="dataContainer">
                    <ViewPage
                      label={t("City")}
                      text={
                        language === "en"
                          ? hqBranchDetails?.city?.en_name
                          : hqBranchDetails?.city?.ar_name
                      }
                    />
                    <ViewPage
                      label={t("building")}
                      text={hqBranchDetails.building}
                    />
                    <ViewPage label={t("floor")} text={hqBranchDetails.floor} />
                    <ViewPage
                      label={t("office")}
                      text={hqBranchDetails.office}
                    />
                    <ViewPage
                      label={t("address")}
                      text={hqBranchDetails.address}
                    />
                  </FormDataContainer>
                </Col>
                <Col md={12} className="mb-4">
                  <HeadingStyled
                    size="20px"
                    weight="400"
                    color="var(--text)"
                    className="mb-2"
                  >
                    {t("contact")}
                  </HeadingStyled>
                  <FormDataContainer className="dataContainer">
                    <ViewPage
                      label={t("contact_person")}
                      text={hqBranchDetails?.contact_person?.name}
                    />
                    <ViewPage
                      label={t("contact_number")}
                      text={hqBranchDetails.contact_no}
                    />
                    <ViewPage
                      label={t("contact_email")}
                      text={hqBranchDetails.email}
                    />
                    <ViewPage
                      label={t("admin_name")}
                      text={hqBranchDetails?.location_admin?.name}
                      render={() => (
                        <Box className="d-flex align-items-center gap-2">
                          <SpanStyled size="14px" color="var(--text2)">
                            {hqBranchDetails?.location_admin?.name}
                          </SpanStyled>
                          {hqBranchDetails?.location_admin && (
                            <TooltipInfo
                              data={[
                                {
                                  value: hqBranchDetails?.location_admin?.email,
                                  title: "email",
                                },
                                {
                                  value: hqBranchDetails?.location_admin?.phone,
                                  title: "phone",
                                },
                              ]}
                            />
                          )}
                        </Box>
                      )}
                    />
                    <ViewPage
                      label={t("number_of_users")}
                      text={`${hqBranchDetails.users_detail_count}`}
                    />
                  </FormDataContainer>
                </Col>
              </Row>
            )}
          </>
        )}
      </Box>
    </HQBranchDetailsWrapper>
  );
};

export default HQBranchDetails;
